import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

import { yellowAttentionText } from 'src/styles/theme'

export const AttentionText = styled(Typography)`
   color: ${yellowAttentionText};
` as typeof Typography
